// Form <-> API conversion for poll options, including the optional rich
// fields (image, subtitle, tags, description, link) that turn a poll into
// option cards. Tags are edited as one comma-separated string.
import type { PollAnswer, PollAnswerDetails } from "@shared/types/api";

export interface PollAnswerFormValue {
  // Not `id`: react-hook-form's useFieldArray uses that for its own row keys.
  answerId?: string;
  text: string;
  imageUrl: string;
  subtitle: string;
  tags: string;
  description: string;
  linkUrl: string;
}

export const emptyPollAnswer = (): PollAnswerFormValue => ({
  text: "",
  imageUrl: "",
  subtitle: "",
  tags: "",
  description: "",
  linkUrl: "",
});

export function toPollAnswerForm(a: PollAnswer): PollAnswerFormValue {
  return {
    answerId: a.id,
    text: a.text,
    imageUrl: a.imageUrl ?? "",
    subtitle: a.subtitle ?? "",
    tags: (a.tags ?? []).join(", "),
    description: a.description ?? "",
    linkUrl: a.linkUrl ?? "",
  };
}

/** Request shape for one option; empty detail fields are left out. */
export function fromPollAnswerForm(f: PollAnswerFormValue): PollAnswerDetails & { id?: string; text: string } {
  const tags = f.tags.split(",").map((t) => t.trim()).filter(Boolean);
  return {
    ...(f.answerId ? { id: f.answerId } : {}),
    text: f.text.trim(),
    ...(f.imageUrl ? { imageUrl: f.imageUrl } : {}),
    ...(f.subtitle.trim() ? { subtitle: f.subtitle.trim() } : {}),
    ...(tags.length ? { tags } : {}),
    ...(f.description.trim() ? { description: f.description.trim() } : {}),
    ...(f.linkUrl.trim() ? { linkUrl: f.linkUrl.trim() } : {}),
  };
}

export function hasPollAnswerDetails(f: PollAnswerFormValue): boolean {
  return !!(f.imageUrl || f.subtitle || f.tags || f.description || f.linkUrl);
}
